module.exports = __webpack_public_path__ + "static/media/backimag.0a8b25ca.svg";